import { HttpClient, storageTokenSave } from "../core/request"
import { loadCities } from "./filters"
import createStore from './createStore'

// ------------------------------------
// Constants
// ------------------------------------
export const LOGIN_FORM_CHANGE_VISIBLE = 'LOGIN_FORM_CHANGE_VISIBLE';
export const LOGIN_SET_TOKEN = 'LOGIN_SET_TOKEN';
export const USER_ME = 'USER_ME';
export const NOWAIT_FLAG = 'NOWAIT_FLAG';

// ------------------------------------
// Actions
// ------------------------------------
export function loginFormVisible (show = false) {
  return {
    type    : LOGIN_FORM_CHANGE_VISIBLE,
    payload : show
  }
}

export function setNoWaitFlag(value) {
    return {
        type    : NOWAIT_FLAG,
        payload : value
    }
}

export function setToken (token, rememberMe = false, nowait=false) {
    storageTokenSave(token, rememberMe);
    if (token) {
        createStore.dispatch(me(nowait));
    }
    return {
        type    : LOGIN_SET_TOKEN,
        payload : token
    }
}

export function setUserData (data) {
    return {
        type    : USER_ME,
        payload : data
    }
}

export function logout() {
    storageTokenSave(false);
    return {
        type    : LOGIN_SET_TOKEN,
        payload : false
    }
}

export const getToken = (email, password, rememberMe = false) => {
    return (dispatch, getState) => {
        return HttpClient().post('session', {
            email: email,
            password: password,
        }).then(data => {
            let token = data.data.token;
            dispatch(setToken(token, rememberMe));
        });
    }
};

export const getTokenFromFacebook = (accessToken) => {
    return (dispatch, getState) => {
        return HttpClient().post('account/facebook-login', {
            token: accessToken
        }).then(data => {
            let token = data.data.token;
            dispatch(setToken(token));
        }).catch(error => { console.log('Error', error) });
    }
};

export const me = (nowait=false) => {
    return (dispatch, getState) => {
        return HttpClient(true).get('me').then(resp => {
            let userData = resp.data;            
            dispatch(setUserData({
                firstName: userData.first_name,
                lastName: userData.last_name,
                zip: userData.zip_code,
                gender: userData.gender,
                email: userData.email,
                phone: userData.phone
            }));

            dispatch(loadCities(userData.zip_code));
            dispatch(setNoWaitFlag(nowait));
        });
    }
};

// ------------------------------------
// Reducer
// ------------------------------------
export function loginFormReducer (state = false, action) {
    return action.type === LOGIN_FORM_CHANGE_VISIBLE
        ? action.payload
        : state
}

export function loginTokenReducer (state = false, action) {
    return action.type === LOGIN_SET_TOKEN
        ? action.payload
        : state
}

export function userDataReducer (state = false, action) {
    return action.type === USER_ME
        ? action.payload
        : state
}

export function nowaitFlagReducer(state=false, action) {
    return action.type === NOWAIT_FLAG
    ? action.payload
    : state
}



// WEBPACK FOOTER //
// ./src/store/login.js